export const getCsrfTokenFromCookies = () => {
    const csrfCookie = document.cookie
        .split('; ')
        .find(row => row.startsWith('csrf_token='));

    if (csrfCookie) {
        return csrfCookie.split('=')[1];
    }
    return null;
};

export const setCsrfTokenToCookies = (token) => {
    document.cookie = `csrf_token=${token}; path=/; Secure; SameSite=Strict`;
};